import { Form, Col } from "react-bootstrap";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Link } from 'react-router-dom';
import { FaChalkboard } from 'react-icons/fa';
import Button from '../../../components/Button/Button';
import Input from '../../../components/Input/Input';
import Select from '../../../components/Select/Select';
import AssignmentGrid from '../../../components/AssignmentGrid/AssignmentGrid';

const CircularForm = ({ changeHandler, submitHandler, fileUploadHandler, loading,
  handleInputChange, handleSwitchChange, circular_desc, circular_topic, circular_no,
  is_ews, circular_file, id, programData, program_ids, availableplaceholders }) => {

  return (
    <Form onSubmit={submitHandler}>
      <div className="row">
        <div className="col-md-6 mb-3">
          <Input
            label="Circular Topic"
            name="circular_topic"
            type="text"
            placeholder={'Enter Circular Topic'}
            value={circular_topic}
            onChangeHandler={(e) => changeHandler(e)}
          />
        </div>
        <div className="col-md-6 mb-3">
          <Input
            label="Circular No"
            name="circular_no"
            type="text"
            placeholder={'Enter Circular No'}
            value={circular_no}
            disabled={id}
            onChangeHandler={(e) => changeHandler(e)}
          />
        </div>
        <div className="col-md-6 mb-3">
          <Input
            label="Circular File"
            name="circular_file"
            type="file"
            onChangeHandler={(e) => fileUploadHandler(e)}
          />
          {id && <Link to={circular_file} target="_blank">View File</Link>}
        </div>
        <div className="col-md-6 mb-3">
          <Select
            label={'Only for Ews students'}
            name="is_ews"
            value={is_ews}
            placeholder={'Choose Ews'}
            options={[
              { id: 1, name: 'Yes' },
              { id: 0, name: 'No' },
            ]}
            onChangeHandler={(e) => changeHandler(e)}
          />
        </div>
        {/* placeholders */}
        {availableplaceholders?.length > 0 && (
          <Col xs={12} className="mb-3">
            <div className="assignment-grid-panel">
              <strong className="mb-2 d-block text-muted">Use these placeholders in circular to auto-fill student info:</strong>
              <div className="d-flex flex-wrap gap-2 mt-2">
                {availableplaceholders.map((ph, i) => (
                  <code key={i} className="bg-white px-2 py-1 rounded border">{ph}</code>
                ))}
              </div>
            </div>
          </Col>
        )}
        <div className="col-md-12 mb-3">
          <Form.Group>
            <Form.Label>Description</Form.Label>
          </Form.Group>
          <CKEditor
            editor={ClassicEditor}
            data={circular_desc}
            onChange={(event, editor) => {
              const data = editor.getData();
              changeHandler({ target: { name: 'circular_desc', value: data } });
            }}
          />
        </div>

        <AssignmentGrid
          label="Available for classes"
          icon={<FaChalkboard />}
          items={programData}
          selectedIds={program_ids}
          onToggle={handleInputChange}
          onSelectAll={handleSwitchChange}
          switchName="program_ids"
        />

        <div className="row d-flex justify-content-end mt-3">
          <div className="col-md-1">
            <Button variant="primary"
              disabled={loading}
              type="submit">
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Form>);
};
export default CircularForm;
